module.exports = __webpack_public_path__ + "img/slide4.e6731498.png";